import { Injectable } from '@angular/core';
import { ModulTema } from './modul-tema';

/**
 *  AZ APP-KERET MŰVELETEI a modulok saját fejlécének.
 *
 *  A profil, az intézmény- és a modulváltás logikája az app-keretben (AppComponent) él, a bal
 *  oldali sávban. A Könyvelés (NAPLO) és a Bérszámfejtés (BER) asztali nézetben bal sáv nélkül
 *  dolgozik, ezért ugyanezt egy fejléc-lenyíló (ProfilMenuComponent) kínálja fel – és hogy a
 *  kettő ne térjen el, a lenyíló nem másolja a logikát, hanem ezen át az app-keretét hívja.
 */
export interface KeretApi {
  avatarUrl(): string;
  avatarHiba(ev: Event): void;
  logoUrl(): string;
  logoHiba(ev: Event): void;
  nev(): string;
  intezmenyNev(): string;
  intezmenyId(): string;
  intezmenyek(): any[];
  modok(): { name: string; cim: string }[];
  aktualisMod(): string;
  fixedMode(): string;
  verzio(): string;
  intezmenyValt(bejegyzes: any): void;
  /*  Alrendszer-váltás. `celUrl` nélkül a semleges „választó" kezdőlapra érkezünk (a váltóból ez a
   *  helyes: nem tudjuk, hova akar menni). Aki KONKRÉT képernyőre visz át – pl. a Könyvelés
   *  ügyfélkártyája a bérszámfejtésre –, megadja a célt, és a váltás után ott landolunk. */
  modValt(mod: { name: string; cim: string }, celUrl?: string): void;
  kilepes(): void;
  /** Az aktuális modul most érvényes témája (a kipróbált, ha van; különben az admin által kijelölt). */
  tema(): ModulTema;
  /** Az admin által a modulhoz kijelölt téma. */
  kijeloltTema(): ModulTema;
  /** Kipróbálhatja-e / kijelölheti-e a témát (a modul adminja, és a modulnak van Fókusz-kerete). */
  temaValaszthato(): boolean;
  /** Kipróbálás – csak ebben a böngészőben; null = vissza a kijelölthöz. */
  temaProba(tema: ModulTema | null): void;
  /** A modul témájának kijelölése (mindenkinek) – csak adminnak. */
  temaMent(tema: ModulTema): Promise<void>;
}

@Injectable({ providedIn: 'root' })
export class KeretService {
  private api: KeretApi | null = null;
  regisztral(api: KeretApi) { this.api = api; }
  get a(): KeretApi | null { return this.api; }
  /*  NAVIGÁLÁS EGY MODUL ÚTVONALÁRA, AZ ALRENDSZERREL EGYÜTT. Ha a cél a másik alrendszeré (pl. a
   *  Könyvelésből egy /ber/… oldal), nem elég az útvonal: az alrendszert is át kell váltani, különben
   *  a menü és a jogkör a régié marad, és onnan nem lehet visszatalálni. Visszatér: true, ha a
   *  keret váltott (és ő navigál); false, ha nincs mit váltani – ilyenkor a hívó navigál. */
  modulba(modul: string, url: string): boolean {
    const k = this.api;
    if (!k || k.fixedMode?.() || k.aktualisMod() === modul) return false;
    const mod = (k.modok() || []).find((m) => m.name === modul);
    if (!mod) return false;
    k.modValt(mod, url);
    return true;
  }
}
